// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__QsOPZ","lineButtons":"vehicleItem_lineButtons__99Me8","twoInLine":"vehicleItem_twoInLine__K+aD8"};